<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.akislar"  url="CreateProject" :show_button="false" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>

<div class="content_card_content">


<!--
<ContentTable :data="data" :columns="columns" routename="Flow" deleteobjectname="flow" @dataDeleted="getData"></ContentTable>
-->

<SortableTableExtended :getroute="list_route" :columns="columns" routename="Flow" deleteobjectname="flow" @dataDeleted="getData" :pageble="false"></SortableTableExtended>

</div>





</div>







</div>
</template>

<script>
export default {

  name: 'Projects',

  data () {
    return {
    	data:[],
      list_route:null,
      columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        hide_on_mobile:false,
        translated:true,
      },     
      {
        type:"pill",
        field:"type",
        header:"tur",
        selectors:["self_evaluation","verification","education","audit"],
        options:[
          {
            name:"self_evaluation",
            color:"#ff6600",
            text:"self_evaluation",
          },
          {
            name:"verification",
            color:"#7e2f8d    ",
            text:"verification",
          },
          {
            name:"education",
            color:"#3b82f6",
            text:"education",
          },
          {
            name:"audit",
            color:"#352f8d",
            text:"audit",
          },
        ],
      }, 
      {
        type:"text",
        field:"brand_name",
        header:"marka",
        hide_on_mobile:true,
      },
      {
        type:"text",
        field:"project_name",
        header:"proje",
        hide_on_mobile:true,
      },     
      {
        type:"date",
        field:"created_at",
        header:"eklenme_tarihi",
        hide_on_mobile:true,
      },

      ]
    }
  },
  mounted()
  {
  	if(this.$store.state.auth.user.userroles[0].name=="brand")
    {
      this.list_route = "user_flows/"+this.$store.state.auth.user.id
    }
    else
    {        
      //data = await this.generalApiGet("flows") 
      this.list_route = "flows"
    }
  },
  methods:{
  	async getData()
  	{
  		let data 

      if(this.$store.state.auth.user.userroles[0].name=="brand")
      {
        data = await this.generalApiGet("user_flows/"+this.$store.state.auth.user.id) 
      }
      else
      {        
        data = await this.generalApiGet("flows") 
      }

      await console.log(data)



      for(let item of data)
      {
        item.type=this.$store.state.languages.lang_phrases[item.type]
        item.suppliers_count = item.meta.suppliers_count
        //item.brand_name = item.brand.name
        //item.project_name = item.project.name
      }
      this.data = await data
      console.log(this.data);
      await this.$store.dispatch('flows/setFlows',this.data)
  	},
  	
  }
};
</script>

<style lang="css" scoped>
</style>